import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getPositionDates } from '../position-dates.routes';
import { GetPositionDatesParams, PositionDatesMap } from '../types';

/**
 * Hook to fetch section position dates (overview + per-fund map from get_position_dates).
 */
export const usePositionDates = (
  params: GetPositionDatesParams,
  options?: Omit<
    UseQueryOptions<PositionDatesMap, AxiosError, PositionDatesMap>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<PositionDatesMap, AxiosError>({
    ...options,
    queryKey: [
      'position-dates',
      params.fundTypes,
      params.rsResources,
      params.raptorPlatformId,
    ],
    queryFn: () => getPositionDates(params),
    enabled:
      options?.enabled !== undefined
        ? options.enabled
        : !!params.fundTypes || !!params.rsResources?.length,
    staleTime: options?.staleTime ?? 5 * 60 * 1000,
  });
};
